module.exports = __webpack_public_path__ + "img/engravingRingsize-1.c5c3c8a.png";